import React from "react";

import { Label } from "@packages/ds";
import { useIntl } from "react-intl";

import { APP_NAME } from "Constants/documentationUrls";
import * as Code from "ds/Code";

import * as S from "../Steps.styles";

const Routes = () => {
  const intl = useIntl();

  const routesYaml =
    intl.formatMessage(
      { id: "yaml_routes_description" },
      { appName: APP_NAME }
    ) +
    `\n"https://www.{default}/":\n    type: upstream\n    upstream: "app:http"\n\n"https://{default}/":\n    type: redirect\n    to: "https://www.{default}/"`;

  const exampleFile = intl.formatMessage({ id: "example_file" });
  const routesYamlLabel = intl.formatMessage({ id: "routes_yaml" });

  const labelText = `${exampleFile}: ${routesYamlLabel}`;

  return (
    <S.Wrapper>
      <S.FileExampleLabelWrapper>
        <Label>{labelText}</Label>
      </S.FileExampleLabelWrapper>
      <Code.Block
        singleLine={false}
        isCopyable={false}
        id="routes-yaml"
        separateCopyButton={true}
      >
        {routesYaml}
      </Code.Block>
    </S.Wrapper>
  );
};

export default Routes;
